import { Component, input, output } from '@angular/core';
import { Router } from '@angular/router';
import { Vehicle } from 'src/app/models/vehicle.model';
import { InspectionService } from 'src/app/services/pre-use-inspection/inspection.service';
import { VehicleProvider } from 'src/app/services/providers/vehicle-provider/vehicle-provider';

@Component({
  selector: 'app-vo-vehicle-detail-card',
  templateUrl: './vo-vehicle-detail-card.component.html',
  styleUrls: ['./vo-vehicle-detail-card.component.scss'],
  standalone: false,
})
export class VoVehicleDetailCardComponent {
  /* Vehicle data rendered inside the card */
  vehicle = input<Vehicle>();

  /* Index of the card within the parent list */
  currentIndex = input<number>();

  /* Flags controlling UI actions and visibility */
  isInspect = input<boolean>();
  isMobileApp = input<boolean>();

  /* Emits navigation intent with selected vehicle */
  navigationVehicle = output<Vehicle>();

  constructor(
    private readonly router: Router,
    private readonly inspectionService: InspectionService,
    private readonly vehicleProvider: VehicleProvider
  ) { }

  get selectedIndex(): number {
    return this.vehicleProvider.readSelectedVehicleIdx();
  }

  /* Resolves vehicle image based on vehicle type */
  getVehicleImage(): string {
    const car = this.vehicle();

    if (!car) {
      return 'assets/imgs/no-asset.png';
    }

    switch (car.vehiclE_IMAGE_TYPE?.toLowerCase()) {
      case 'van':
        return 'assets/imgs/van.png';
      case 'truck':
        return 'assets/imgs/truck.png';
      case 'car':
      default:
        return 'assets/imgs/no-asset.png';
    }
  }

  /* Marks the current vehicle as selected */
  selectVehicle(): void {
    const selectedVehicle = this.vehicle();
    const index = this.currentIndex();

    if (!selectedVehicle || index === undefined) {
      return;
    }

    this.vehicleProvider.setSelectedVehicle(selectedVehicle, index);
  }

  /* Emits navigation event for vehicle details */
  navigateVehicleDetails(): void {
    const vehicleDetails = this.vehicle();
    const index = this.currentIndex();

    if (!vehicleDetails) {
      return;
    }

    if (index != undefined && index >= 0) {
      this.vehicleProvider.setSelectedVehicle(vehicleDetails, index);
    }

    this.navigationVehicle.emit(vehicleDetails);
  }

  /* Navigates to not-my-vehicle flow with vehicle context */
  notMyVehicle(): void {
    this.router.navigate(['not-my-vehicle', this.vehicle()?.icN_NO], {
      state: {
        vehicleDetails: this.vehicle(),
      },
    });
  }

  /* Navigates to PUI flow */
  async navigatePui(): Promise<void> {
    await this.inspectionService.navigatePUI(this.vehicle()?.icN_NO?.toString() ?? '', false);
  }
}
